Apt.fn.extend('directory', {
	/**
	 * Get sorting options
	 *
	 * @returns {Object}
	 */
	getSorting() {
		return {
			'-promoted': 'For you',
			'-newest': 'Newest',
			'newest': 'Oldest'
		};
	}
}, {
	/**
	 * Create the directory results application
	 */
	initApp() {
		const scope = this;
		const pub = scope.$public;
		const $results = $$('results');

		scope.index = Apt.fn.index().init({
			controls: '$controls',
			init: false,
			model: {
				label: scope.type.slice(0, -1)
			},
			paginate: true,
			path: scope.type,
			reload: true,
			resource: 'profiles',
			scrollTop: false,
			sorting: pub.getSorting(),
			target: $results,
			validate: true,
			value: $results.data('value'),
			view: 'directory.results',
			params: {
				buffer: true
			},
			send: (xhr, conf) => {
				const data = conf.data;

				LS.util.setScroll($results, null, 20, false);

				if (! data.center) {
					const center = LS.location.center() || LS.user.center();

					if (center) {
						data.center = center;
					}
				}

				if (! data.page || data.page === 1) {
					data.attach = [
						'render'
					];
				}
			},
			updated: (data, init) => {
				scope.updateApp(data.results);

				if (! init) {
					if (data.title) {
						const context = {
							location: data.location || null,
							targeting: null
						};

						document.title = data.title + ' - LandSearch';

						$$('directoryTitle').text(data.heading);

						$.merge('context', context);

						$('.js-context').data('value', context);

						scope.control();
					}

					if (scope.meta && data.current_page === 1) {
						LS.util.destroy(scope, 'meta');

						$$('directoryFooter').remove();
					}
				}

				if (scope.fallback) {
					scope.fallback.$destroy();
				}

				if (data.total <= 6) {
					scope.fallbackApp(
						LS.util.pluck(data.results, 'id')
					);
				}

				scope.updateRelevant(data);
			},
			unload: () => {
				scope.$private.unbind();
			},
			destroy: () => {
				Apt.panel.unload();
			}
		}, () => {
			if (location.hash === '#inactive') {
				LS.util.flash('Inactive profile — search nearby');
			}

			let path;

			Apt.panel.init({
				opening: () => {
					path = $.routes.uri().path;
				},
				opened: () => {
					scope.path = path;
				},
				closed: () => {
					if (Apt.profile) {
						Apt.profile.unload();
					}

					if (Apt.property) {
						Apt.property.unload();
					}
				}
			});

			$.events.on('.card a', 'mousedown', (e, el) => {
				const avatar = $('img', el)[0];

				if (avatar) {
					new Image().src = avatar.src.replace('/small/', '/large/');
				}
			}, {
				delegate: '$results',
				namespace: 'directory'
			});

			$results[0].dataset.value = '';
		});
	},

	/**
	 * Update the directory view
	 *
	 * @param {Object} data
	 */
	updateApp(data) {
		if (! data || ! data.length) {
			return;
		}

		Object.values(data).forEach(item => {
			LS.analytics.track({
				action: 'preview',
				target: 'profile',
				id: item.id,
				category: 'entry',
				segment: 'results'
			}, {
				send: false
			});
		});

		LS.analytics.send();
	},

	/**
	 * Update relevant listings
	 *
	 * @param {Object} data
	 */
	updateRelevant(data) {
		const scope = this;
		const $side = $$('sidePromoted');

		let limit;

		if ($.screen.size() < 4) {
			$side.hide();

			return;
		}

		limit = Math.max(
			2, Math.round(((data.results || []).length + (data.total < 6 ? 6 : 0)) / 5)
		);

		if (scope.relevant) {
			scope.relevant.update({
				limit: limit
			});

			return;
		}

		scope.relevant = Apt.fn['properties.relevant']().init({
			params: {
				limit: limit,
				random: true
			},
			updated: () => {
				$side.show();
			}
		});
	},

	/**
	 * Refresh application
	 */
	refresh() {
		this.index.update({
			event: false
		}, LS.filters.get());
	},

	/**
	 * Display fallback results
	 *
	 * @param {Array} ids
	 */
	fallbackApp(ids) {
		const scope = this;
		const params = LS.filters.get();
		const $element = $($.view.render('directory.fallback', {
			empty: ! ids.length,
			location: LS.location.heading(
				$.context('location')
			)
		}));

		if (! params.location) {
			return;
		}

		delete params.location;

		params.exclude = ids;
		params.limit = 6;

		$$('results').after($element);

		scope.fallback = Apt.fn['directory.relevant']().init({
			filters: params,
			resource: 'profiles',
			updated: data => {
				if (! data.results.length) {
					return;
				}

				$element.show();
			},
			unload: () => {
				scope.fallback = null;

				$element.remove();
			}
		});
	}
});